import React, { Suspense } from 'react';
import { useImage } from 'react-image';
import PlaceholderImage from '../../../assets/placeholder/product_placeholder.png';

const ImageSuspenseComponent = (props: { src: string; htmlClass?: string; htmlAlt?: string }) => {
  const { src } = useImage({
    srcList: [props.src, PlaceholderImage],
  });

  return <img src={src} className={props.htmlClass} alt={props.htmlAlt} />;
};

export const ImageComponent = (props: { src: string; htmlClass?: string; htmlAlt?: string }) => {
  return (
    <Suspense fallback={<></>}>
      <ImageSuspenseComponent src={props.src} htmlClass={props.htmlClass} htmlAlt={props.htmlAlt} />
    </Suspense>
  );
};
